export default {
  state: {
    notificationNewBooking: {
      show: false,
      text: null,
      id: null,
      isPackage: null,
      status: null,
      isLoading: false
    }
  },
  mutations: {
    showNotificationNewBooking (state, data) {
      state.notificationNewBooking.show = true
      state.notificationNewBooking.text = data.text
      state.notificationNewBooking.status = data.status
      state.notificationNewBooking.id = data.id
      state.notificationNewBooking.isPackage = data.isPackage
      state.notificationNewBooking.isLoading = false
    },
    hideNotificationNewBooking (state) {
      state.notificationNewBooking.show = false
      state.notificationNewBooking.text = null
      state.notificationNewBooking.status = null
      state.notificationNewBooking.id = null
      state.notificationNewBooking.isPackage = null
      state.notificationNewBooking.isLoading = false
    },
    loadNewBookingNotification (state) {
      state.notificationNewBooking.isLoading = true
    }
  },
  sharedMutations: [
    'dispatch/showNotificationNewBooking',
    'dispatch/hideNotificationNewBooking'
  ]
}



// WEBPACK FOOTER //
// ./src/store/dispatch/notification-new-booking.js